<template>
    <button type="button" class="primary-btn" @click="$emit('click')">
        <span class="btn-content">

            <Download class="icon" />

            <span>
                <slot />
            </span>

        </span>
    </button>
</template>

<script>
import { Download } from 'lucide-vue-next'

export default {
    name: 'PrimaryButton',
    components: {
        Download
    }
};
</script>

<style scoped>
.primary-btn {
    width: 100%;
    height: 42px;
    border-radius: 12px;

    font-size: 13px;
    font-weight: 600;
    color: #fff;

    background: linear-gradient(135deg, #02162d, #36e0f7);
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.18s ease;
    cursor: pointer;
}

/* CONTENIDO */
.btn-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ICONO */
.icon {
    width: 16px;
    height: 16px;
    stroke-width: 2;
}

/* HOVER */
.primary-btn:hover {
    box-shadow: 0 6px 16px rgba(54, 224, 247, 0.25);
    transform: translateY(-1px);
}

/* ACTIVE */
.primary-btn:active {
    transform: translateY(0);
    box-shadow: none;
}

/* FOCUS */
.primary-btn:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(77, 158, 193, 0.3);
}
</style>